module.exports = __webpack_public_path__ + "img/s1_img-s.a62aa397.png";